import { IConfigRoutePath, IConfigRoute } from '../interface/config';
import { IEnv } from '../interface/util';

function route(env: IEnv): IConfigRoute {
    /* Pull the basename from env, if empty use '' */
    const basenameIn = env.getString('REACT_APP_ROUTE_BASENAME') ?? '';
    /* & make sure it starts/ends with '/', removing any '//' along the way, So if unset we'll get '/', if we get 'develop/ork' the output will be '/develop/ork/' */
    const basename = `/${basenameIn}/`.replace(/\/+/g, '/');

    const config: IConfigRoute = {
        basename,
        routes: {
            [IConfigRoutePath.Launch]: {
                pathPrefix: '/',
                pathMatch: ['/', '/launch*'],
            },
            [IConfigRoutePath.LanguageSelect]: {
                pathPrefix: '/languageselect',
                pathMatch: ['/languageselect', '/ls'],
            },
            [IConfigRoutePath.TourSelect]: {
                pathPrefix: '/tourselect',
                pathMatch: ['/tourselect*', '/ts*'],
            },
            [IConfigRoutePath.Tour]: {
                pathPrefix: '/tour',
                pathMatch: ['/tour*'],
            },
            [IConfigRoutePath.SiteObject]: {
                pathPrefix: '/siteobject',
                pathMatch: ['/siteobject*', '/so*'],
            },
            [IConfigRoutePath.FloorPlan]: {
                pathPrefix: '/floorplan',
                pathMatch: ['/floorplan*', '/fp*'],
            },
        },
    };

    return config;
}

export default route;
